import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import "../../styles/customers/createCustomer.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import CustomerMap from "../maps/customerMap";
import renderHTML from "react-render-html";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { searchSuggestionAPI, reverseGeoCodeAPI, GeoCodeAPI } from "../../utils/mapapi";

class CreateCustomer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      timeZoneArr: [],
      lat: -37.8136276,
      lng: 144.9630576,
      address: "Thelangerin Rd, Hay NSW 2711, Australia",
      suggestions: [],
      suggestionVisibility: false,
      searchText: "",
      name: "",
      description: "",
      status: "Active",
      timeZone: "",
      tempA: "8",
      tempB: "-12",
      speedException: 3,
      error: false,
      errorSearch: false,
      nameError: false,
      descriptionError: false,
      statusError: false,
      timeZoneError: false,
      speedError: false,
      temperatureThresholdDuration: 30,
      temperatureThresholdDurationError: false,
      fridgeEventTrigger: "on",
      engineEventTrigger: "off",
    };
  }
  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllTimeZone`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ timeZoneArr: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  handlePositionChange = async (position) => {
    this.setState({ lat: position.lat, lng: position.lng });

      try {
          let address = await reverseGeoCodeAPI(position.lat, position.lng);
          this.setState({ address });
      } catch (e) {
          if (e.response.status == "401") {
              this.props.history.push("/login");
          }
          console.log(`😱 Axios request failed: ${e}`);
      }
  };

  handleCancel = () => {
    this.props.history.push("/customers");
  };

  handleName = (evt) => {
    if (evt.target.value == "") {
      this.setState({ nameError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.setState({ name: evt.target.value });
  };

  handleDescription = (evt) => {
    if (evt.target.value == "") {
      this.setState({ descriptionError: true });
    } else {
      this.setState({ descriptionError: false });
    }
    this.setState({ description: evt.target.value });
  };

  handleStatus = (evt) => {
    if (evt.target.value == "") {
      this.setState({ statusError: true });
    } else {
      this.setState({ statusError: false });
    }
    if (evt.target.value == "Active") {
      this.setState({ status: "Active" });
    } else {
      this.setState({ status: "Disable" });
    }
  };

  handleFridgeEventTrigger = (evt) => {
    if (evt.target.value == "Fridge-On") {
      this.setState({ fridgeEventTrigger: "on" });
    } else if (evt.target.value == "Fridge-Off") {
      this.setState({ fridgeEventTrigger: "off" });
    } else {
      this.setState({ fridgeEventTrigger: "always" });
    }
  };

  handleEngineEventTrigger = (evt) => {
    if (evt.target.value == "Engine-On") {
      this.setState({ engineEventTrigger: "on" });
    } else if (evt.target.value == "Engine-Off") {
      this.setState({ engineEventTrigger: "off" });
    } else {
      this.setState({ engineEventTrigger: "always" });
    }
  };

  handleTimeZone = (evt) => {
    if (evt.target.value == "") {
      this.setState({ timeZoneError: true });
    } else {
      this.setState({ timeZoneError: false });
    }
    this.state.timeZoneArr.forEach((time) => {
      if (time.timeZoneCity == evt.target.value) {
        this.setState({ timeZone: time.timeZonesId });
      }
    });
  };

  //Map searching and search suggestion starts here
  handleLocationChange = (searchText) => {
    this.setState({ searchText });
    this.handleSearchSuggestion(searchText);
  };

    handleSearch = async () => {
        try {
            console.log("searec1", this.state.searchText);
            const { lat, lng } = await GeoCodeAPI(this.state.searchText);

            if (lat !== 0 && lng !== 0) {
                this.setState({
                    lat: lat,
                    lng: lng,
                });
            } else {
                this.setState({ errorSearch: true });
                setTimeout(() => {
                    this.setState({ errorSearch: false });
                }, 1000);
            }

        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
            }
            console.log(`😱 Axios request failed: ${e}`);
        }
    };

    handleSearchSuggestion = async (query) => {
        if (query != "") {
            this.setState({ suggestionVisibility: false });
        }
        this.setState({ suggestionVisibility: true });
        try {
            const items = await searchSuggestionAPI(query);
            this.setState({ suggestions: items });
        } catch (e) {
            console.log(e);
        }
        // }
    };
  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      console.log("enter press here! ", event.target.value);
      this.handleSuggestionClick(event.target.value);
    }
  };
    handleSuggestionClick = async (place) => {
        var nwlocation = place.replace("<b>", "");
        var location = nwlocation.replace("</b>", "");

        this.setState({ searchText: location, suggestionVisibility: false });
        try {
            console.log("searecyy", location);
            const { lat, lng } = await GeoCodeAPI(location);

            if (lat !== 0 && lng !== 0) {
                this.setState({
                    lat: lat,
                    lng: lng,
                });
                let position = {
                    lat: lat,
                    lng: lng,
                };
                this.handlePositionChange(position);
            } else {
                this.setState({ errorSearch: true });
                setTimeout(() => {
                    this.setState({ errorSearch: false });
                }, 1000);
            }
        } catch (e) {
            console.log(`😱 Axios request failed: ${e}`);
        }
    };

  //Map searching and search suggestion ends here
  handleTempA = (e) => {
    this.setState({ tempA: e.target.value });
  };
  handleTempB = (e) => {
    this.setState({ tempB: e.target.value });
  };
  handleSpeedException = (e) => {
    if (e.target.value == "") {
      this.setState({ speedError: true });
    } else {
      this.setState({ speedError: false });
    }
    this.setState({ speedException: e.target.value });
  };

  handleTemperatureThresholdException = (e) => {
    if (e.target.value == "") {
      this.setState({ temperatureThresholdDurationError: true });
    } else {
      this.setState({ temperatureThresholdDurationError: false });
    }
    this.setState({ temperatureThresholdDuration: e.target.value });
  };

  handleSubmit = async () => {
    this.validationCheck();

    if (
      this.state.name &&
      // this.state.description &&
      this.state.timeZone &&
      this.state.speedException &&
      this.state.temperatureThresholdDuration
    ) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/Customer/CustomerRegistration`,
          {
            Name: this.state.name,
            Description: this.state.description,
            Status: this.state.status,
            TimeZonesId: this.state.timeZone,
            Latitude: this.state.lat,
            Longitude: this.state.lng,
            SpeedExceptionDurationLimit: this.state.speedException,
            TempA: this.state.tempA,
            TempB: this.state.tempB,
            TemperatureThresholdDuration: this.state
              .temperatureThresholdDuration,
            FridgeEventTrigger: this.state.fridgeEventTrigger,
            EngineEventTrigger: this.state.engineEventTrigger,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        if (response.status == "200") {
          this.props.history.push("/customers");
          this.props.setLoadingPageAction(false);
        }
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  validationCheck = () => {
    if (!this.state.name) {
      this.setState({ nameError: true });
    }
    // if (!this.state.description) {
    //   this.setState({ descriptionError: true });
    // }
    if (!this.state.status) {
      this.setState({ statusError: true });
    }
    if (!this.state.timeZone) {
      this.setState({ timeZoneError: true });
    }
    if (!this.state.speedException) {
      this.setState({ speedError: true });
    }
    if (!this.state.temperatureThresholdDuration) {
      this.setState({ temperatureThresholdDurationError: true });
    }
  };

  render() {
    const {
      timeZoneArr,
      lat,
      lng,
      address,
      nameError,
      descriptionError,
      statusError,
      timeZoneError,
      speedError,
      temperatureThresholdDurationError,
    } = this.state;
    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Create Customer </title>
          </Helmet>
          <div>
            <div className="formGroupCustomer">
              <h1>New Customer</h1>
              <Form>
                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>Name</span>
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      onChange={this.handleName}
                      type="plaintext"
                      placeholder=""
                    />
                    <p
                      style={
                        nameError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Name field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlaintextArea">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>Description</span>
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      as="textarea"
                      rows="3"
                      onChange={this.handleDescription}
                    />
                    <p
                      style={
                        descriptionError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Description field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlainStatus">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>Status</span>
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control as="select" onChange={this.handleStatus}>
                      <option>Active</option>
                      <option>Disabled</option>
                    </Form.Control>
                    <p
                      style={
                        statusError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Status field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlainStatus">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>Fridge Event Trigger</span>
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      as="select"
                      onChange={this.handleFridgeEventTrigger}
                    >
                      <option>Fridge-On</option>
                      <option>Fridge-Off</option>
                      <option>Always</option>
                    </Form.Control>
                    {/* <p
                      style={
                        statusError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Status field is required.
                    </p> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlainStatus">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>Engine Event Trigger</span>
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      as="select"
                      onChange={this.handleEngineEventTrigger}
                    >
                      <option>Engine-On</option>
                      <option>Engine-Off</option>
                      <option>Always</option>
                    </Form.Control>
                    {/* <p
                      style={
                        statusError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Status field is required.
                    </p> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlainStatus">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>Temp A Threshold</span>
                  </Form.Label>
                  <Col sm="1">
                    <Form.Control
                      onChange={this.handleTempA}
                      type="plaintext"
                      placeholder=""
                      value={this.state.tempA}
                    />
                    {/* <p style={statusError?{color:'#a94442',fontSize:'14px'}:{display:'none'}}>The Status field is required.</p>  */}
                  </Col>
                </Form.Group>{" "}
                <Form.Group as={Row} controlId="formPlainStatus">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>Temp B Threshold</span>
                  </Form.Label>
                  <Col sm="1">
                    <Form.Control
                      onChange={this.handleTempB}
                      type="plaintext"
                      placeholder=""
                      value={this.state.tempB}
                    />
                    {/* <p style={statusError?{color:'#a94442',fontSize:'14px'}:{display:'none'}}>The Status field is required.</p>  */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlainStatus">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>
                      Speed Exception Duration Limit
                    </span>
                    <span style={{ float: "right", textAlign: "center" }}>
                      ( in Minutes )
                    </span>
                  </Form.Label>
                  <Col sm="1">
                    <Form.Control
                      onChange={this.handleSpeedException}
                      type="number"
                      value={this.state.speedException}
                    />
                    <p
                      style={
                        speedError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The speed field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlainStatus">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>
                      Temperature Threshold Duration
                    </span>
                    <span style={{ float: "right", textAlign: "center" }}>
                      ( in Minutes )
                    </span>
                  </Form.Label>
                  <Col sm="1">
                    <Form.Control
                      onChange={this.handleTemperatureThresholdException}
                      type="number"
                      value={this.state.temperatureThresholdDuration}
                    />
                    <p
                      style={
                        temperatureThresholdDurationError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The temperature threshold duration field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlainTimeZone">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>TimeZone</span>
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      as="select"
                      onChange={(e) => this.handleTimeZone(e)}
                    >
                      <option value="default">Select TimeZone</option>
                      {timeZoneArr.map((time, index) => (
                        <option key={index}>{time.timeZoneCity}</option>
                      ))}
                    </Form.Control>
                    <p
                      style={
                        timeZoneError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The TimeZone field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlainAddress">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>Address</span>
                  </Form.Label>
                  <Col sm="4">
                    <div>
                      Position (
                      <span>
                        {lat}, {lng})
                      </span>
                    </div>
                    <div>{address}</div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2"></Form.Label>

                  {/* <Col sm="6"> */}
                  {/* <Button variant="outline-warning" onClick={()=>this.handleSearch()}>Search</Button> */}
                  {/* </Col> */}
                </Form.Group>
                {this.state.errorSearch && (
                  <Form.Group as={Row} controlId="formPlainAddress">
                    <Form.Label column sm="2"></Form.Label>
                    <Col sm="9">
                      <p className="error-text">No response</p>
                    </Col>
                  </Form.Group>
                )}
                <Form.Group as={Row} controlId="formPlainAddress">
                  <Form.Label column sm="2"></Form.Label>
                  <Col sm="5">
                    <div className="containerMap">
                      <CustomerMap
                        onPositionChange={this.handlePositionChange}
                        lat={lat}
                        lng={lng}
                      ></CustomerMap>
                      <div className="overlaySearch">
                        <Col sm="12" className="inputSuggestions">
                          <Form.Control
                            value={this.state.searchText}
                            onChange={(e) =>
                              this.handleLocationChange(e.target.value)
                            }
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            autocomplete="off"
                            type="plaintext"
                            placeholder="Search location"
                          />
                          {this.state.suggestionVisibility && (
                            <ul>
                              {this.state.suggestions &&
                                this.state.suggestions.map((item, index) => {
                                  return (
                                    <li
                                          key={item.address.label}
                                          onClick={() => this.handleSuggestionClick(item.address.label)}
                                    >
                                          {renderHTML(item.address.label)}
                                    </li>
                                  );
                                })}
                            </ul>
                          )}
                        </Col>
                      </div>
                    </div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlainAddress">
                  <Form.Label column sm="2"></Form.Label>
                  <Col sm="4">
                    <div className="customer_submit">
                      <Button
                        variant="warning"
                        onClick={() => this.handleCancel()}
                      >
                        Cancel
                      </Button>
                      &nbsp;
                      <Button
                        variant="success"
                        onClick={() => this.handleSubmit()}
                      >
                        Create
                      </Button>
                    </div>
                  </Col>
                </Form.Group>
                {this.state.error && (
                  <Form.Group as={Row} controlId="formPlainAddress">
                    <Form.Label column sm="2"></Form.Label>
                    <Col sm="9">
                      <p className="error-text">
                        Please fill all the Required fields
                      </p>
                    </Col>
                  </Form.Group>
                )}
              </Form>
              <br />
            </div>
          </div>
          <br />
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCustomer);
